import React, { Component } from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';

import LineInput from '@dragonfruit/components/fields/LineInput';
import { Button } from '@snapask/common-components';

import {
  PASSWORD,
  NEW_PASSWORD,
} from '@dragonfruit/constants/autocompleteFields';

import Validator from '@dragonfruit/utils/validator';

class ResetPasswordForm extends Component {
  static propTypes = {
    t: func.isRequired,
    onSubmit: func.isRequired,
  };

  state = {
    currentPassword: '',
    currentPasswordError: '',
    newPassword: '',
    newPasswordError: '',
    confirmNewPassword: '',
    confirmNewPasswordError: '',
  };

  handleSubmit = () => {
    const { currentPassword, newPassword, confirmNewPassword } = this.state;

    this.props.onSubmit({
      confirmNewPassword,
      currentPassword,
      newPassword,
    });
  };

  handleCurrentPasswordChange = value =>
    this.setState({ currentPassword: value });
  handleNewPasswordChange = value => this.setState({ newPassword: value });
  handleConfirmNewPasswordChange = value =>
    this.setState({ confirmNewPassword: value });

  validateCurrentPassword = () => {
    const { t } = this.props;
    const validate = new Validator(this.state.currentPassword)
      .isEmpty(t('account.resetPasswordErrors.noEmpty'))
      .minLength(8, t('error:error.not-satisfy-password-pattern'));
    const error = validate.getFirstErrorMessage();

    this.setState({ currentPasswordError: error });
  };

  validateNewPassword = () => {
    const { t } = this.props;
    const validate = new Validator(this.state.newPassword)
      .isEmpty(t('account.resetPasswordErrors.noEmpty'))
      .minLength(8, t('error:error.not-satisfy-password-pattern'));
    const error = validate.getFirstErrorMessage();

    this.setState({ newPasswordError: error });
  };

  validateConfirmNewPassword = () => {
    const { confirmNewPassword, newPassword } = this.state;
    const { t } = this.props;
    const validate = new Validator(confirmNewPassword)
      .isEmpty(t('account.resetPasswordErrors.noEmpty'))
      .minLength(8, t('error:error.not-satisfy-password-pattern'))
      .isMatchWith(newPassword, t('account.resetPasswordErrors.noMatch'));
    const error = validate.getFirstErrorMessage();

    this.setState({ confirmNewPasswordError: error });
  };

  render() {
    const { t } = this.props;

    const {
      currentPasswordError,
      currentPassword,
      newPasswordError,
      newPassword,
      confirmNewPasswordError,
      confirmNewPassword,
    } = this.state;

    const isValid =
      currentPassword &&
      !currentPasswordError &&
      newPassword &&
      !newPasswordError &&
      confirmNewPassword &&
      !confirmNewPasswordError;

    return (
      <div>
        {/* Current Password */}
        <LineInput
          floatingLabelText={t('account.currentPassword')}
          onChange={this.handleCurrentPasswordChange}
          onBlur={this.validateCurrentPassword}
          autoComplete={PASSWORD}
          errorText={!!currentPasswordError && currentPasswordError}
        />

        {/* New Password */}
        <LineInput
          floatingLabelText={t('account.newPassword')}
          onChange={this.handleNewPasswordChange}
          onBlur={this.validateNewPassword}
          autoComplete={NEW_PASSWORD}
          errorText={!!newPasswordError && newPasswordError}
        />

        {/* Confirm New Password */}
        <LineInput
          floatingLabelText={t('account.confirmPassword')}
          onChange={this.handleConfirmNewPasswordChange}
          onBlur={this.validateConfirmNewPassword}
          autoComplete={NEW_PASSWORD}
          errorText={!!confirmNewPasswordError && confirmNewPasswordError}
        />
        <Button
          text={t('account.resetPasswordCta')}
          disabled={!isValid}
          primary
          onClick={this.handleSubmit}
        />
      </div>
    );
  }
}

export default translate(['account', 'error'])(ResetPasswordForm);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountProfileResetPassword/components/ResetPasswordForm/ResetPasswordForm.jsx